<template>
	<div class="news-management">
		<el-card>
			<div slot="header" class="clearfix">
				<span>新闻管理</span>
				<div style="float: right;">
					<el-button type="text" @click="showAddDialog">添加新闻</el-button>
					<el-button type="text" @click="showClassManagement">栏目管理</el-button>
				</div>
			</div>

			<el-row :gutter="20" class="filter-row">
				<el-col :span="6">
					<el-input v-model="filter.title" placeholder="按标题搜索" clearable @clear="fetchNewsList"
						@keyup.enter.native="fetchNewsList">
						<el-button slot="append" icon="el-icon-search" @click="fetchNewsList"></el-button>
					</el-input>
				</el-col>
				<el-col :span="3">
					<el-select v-model="filter.type" placeholder="按类型筛选" clearable @change="fetchNewsList">
						<el-option label="全部类型" value=""></el-option>
						<el-option label="消息" value="message"></el-option>
						<el-option label="活动" value="active"></el-option>
						<el-option label="公告" value="notice"></el-option>
					</el-select>
				</el-col>
				<el-col :span="3">
					<el-select v-model="filter.status" placeholder="按状态筛选" clearable @change="fetchNewsList">
						<el-option label="全部状态" value="all"></el-option>
						<el-option label="已发布" value="published"></el-option>
						<el-option label="未发布" value="unpublished"></el-option>
					</el-select>
				</el-col>
				<el-col :span="3">
					<el-select v-model="filter.class_id" placeholder="按栏目筛选" clearable @change="fetchNewsList">
						<el-option label="全部栏目" value=""></el-option>
						<el-option v-for="item in classList" :key="item.id" :label="item.class_name"
							:value="item.id"></el-option>
					</el-select>
				</el-col>
			</el-row>

			<el-table :data="newsList" border style="width: 100%">
				<el-table-column prop="id" label="ID" width="80"></el-table-column>
				<el-table-column label="封面" width="120">
					<template slot-scope="scope">
						<el-image style="width: 100px; height: 60px" :src="scope.row.cover_image" fit="cover"
							:preview-src-list="[scope.row.cover_image]"></el-image>
					</template>
				</el-table-column>
				<el-table-column prop="title" label="标题"></el-table-column>
				<el-table-column label="栏目" width="120">
					<template slot-scope="scope">
						{{ scope.row.class_name || '无栏目' }}
					</template>
				</el-table-column>
				<el-table-column label="类型" width="100">
					<template slot-scope="scope">
						<el-tag :type="getTypeTag(scope.row.news_type)">
							{{ getTypeName(scope.row.news_type) }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="view_count" label="浏览量" width="100"></el-table-column>
				<el-table-column label="发布时间" width="180">
					<template slot-scope="scope">
						{{ scope.row.publish_time | formatDateTime }}
					</template>
				</el-table-column>
				<el-table-column label="状态" width="100">
					<template slot-scope="scope">
						<el-tag :type="scope.row.is_published ? 'success' : 'info'">
							{{ scope.row.is_published ? '已发布' : '未发布' }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="220">
					<template slot-scope="scope">
						<el-button v-if="!scope.row.is_published" size="mini" type="success"
							@click="handlePublish(scope.row.id)">发布</el-button>
						<el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>

			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
			</el-pagination>
		</el-card>
		<el-dialog title="栏目管理" :visible.sync="classManagementVisible" width="50%">
			<el-table :data="classList" border>
				<el-table-column prop="id" label="ID" width="80"></el-table-column>
				<el-table-column prop="class_name" label="栏目名称"></el-table-column>
				<el-table-column prop="order_by" label="排序" width="100"></el-table-column>
				<el-table-column label="操作" width="180">
					<template slot-scope="scope">
						<el-button size="mini" @click="handleEditClass(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="handleDeleteClass(scope.row)"
							:disabled="scope.row.news_count > 0">删除</el-button>
					</template>
				</el-table-column>
			</el-table>

			<div style="margin-top: 20px;">
				<el-button type="primary" @click="showAddClassDialog">新增栏目</el-button>
			</div>
		</el-dialog>
		<el-dialog :title="classDialogTitle" :visible.sync="classDialogVisible" width="30%" @close="resetClassForm">
			<el-form :model="classForm" :rules="classRules" ref="classForm">
				<el-form-item label="栏目名称" prop="class_name">
					<el-input v-model="classForm.class_name"></el-input>
				</el-form-item>
				<el-form-item label="排序值" prop="order_by">
					<el-input-number v-model="classForm.order_by" :min="0"></el-input-number>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="classDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitClassForm">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 添加/编辑对话框 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="70%" @close="resetForm"
			:close-on-click-modal="false">
			<el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
				<el-form-item label="新闻标题" prop="title">
					<el-input v-model="form.title"></el-input>
				</el-form-item>
				<el-form-item label="所属栏目" prop="class_id">
					<el-select v-model="form.class_id" placeholder="请选择所属栏目" style="width: 300px;">
						<el-option v-for="item in classList" :key="item.id" :label="item.class_name"
							:value="item.id"></el-option>
						<!-- 使用el-option作为按钮的容器 -->
						<el-option disabled style="height: auto; padding: 0;">
							<el-button type="text" @click.stop="showAddClassDialog"
								style="width: 100%; text-align: left; padding-left: 20px;">
								+ 新增栏目
							</el-button>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="新闻类型" prop="news_type">
					<el-select v-model="form.news_type" placeholder="请选择新闻类型">
						<el-option label="消息" value="message"></el-option>
						<el-option label="活动" value="active"></el-option>
						<el-option label="公告" value="notice"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="封面图片" prop="cover_image">
					<el-upload class="avatar-uploader" action="https://www.fossnet.cn/api/upload.php"
						:show-file-list="false" :on-success="handleUploadSuccess" :before-upload="beforeUpload">
						<img v-if="form.cover_image" :src="form.cover_image" class="avatar" />
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="新闻内容" prop="content">
					<wang-editor v-model="form.content"
						upload-url="https://www.fossnet.cn/api/upload.php"></wang-editor>
				</el-form-item>
				<!-- <el-form-item label="添加附件" prop="files">
					<el-upload class="avatar-uploader" action="https://www.fossnet.cn/api/upload.php"
						:show-file-list="false" :on-success="handleUploadFileSuccess">
						<span v-if="form.file !== '' && form.file !== null">{{form.file}}&emsp;<span
								style="color: #f00;" @click.stop="deleteFile()">删除</span></span>
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item> -->
				<el-form-item label="发布时间">
					<el-date-picker v-model="form.publish_time" type="datetime" placeholder="选择发布时间"
						value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
				</el-form-item>
				<el-form-item label="发布状态">
					<el-switch v-model="form.is_published" :active-value="1" :inactive-value="0"></el-switch>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitForm">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 新增栏目对话框 -->
		<el-dialog title="新增栏目" :visible.sync="classDialogVisible" width="30%">
			<el-form :model="classForm" :rules="classRules" ref="classForm" label-width="100px">
				<el-form-item label="栏目名称" prop="class_name">
					<el-input v-model="classForm.class_name" placeholder="请输入栏目名称"></el-input>
				</el-form-item>
				<el-form-item label="排序值" prop="order_by">
					<el-input-number v-model="classForm.order_by" :min="0" :step="1"></el-input-number>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="classDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitClassForm">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		apiBaseUrl
	} from '@/config';
	import WangEditor from '@/components/WangEditor.vue'

	export default {
		components: {
			WangEditor
		},
		filters: {
			formatDateTime(value) {
				if (!value) return '-';
				const date = new Date(value);
				return date.toLocaleString();
			}
		},
		data() {
			return {
				newsList: [],
				classList: [],
				filter: {
					title: '',
					type: '',
					status: 'all',
					class_id: ''
				},
				pagination: {
					currentPage: 1,
					pageSize: 10,
					total: 0
				},
				dialogVisible: false,
				classDialogVisible: false,
				dialogTitle: '添加新闻',
				form: {
					id: '',
					title: '',
					class_id: '',
					cover_image: '',
					content: '',
					news_type: 'message',
					publish_time: new Date(),
					is_published: "0",
				},
				classForm: {
					id: '',
					class_name: '',
					order_by: 0
				},
				rules: {
					title: [{
							required: true,
							message: '请输入新闻标题',
							trigger: 'blur'
						},
						{
							max: 100,
							message: '长度不能超过100个字符',
							trigger: 'blur'
						}
					],
					class_id: [{
						required: true,
						message: '请选择所属栏目',
						trigger: 'change'
					}],
					cover_image: [{
						required: true,
						message: '请上传封面图片',
						trigger: 'change'
					}],
					content: [{
						required: true,
						message: '请输入新闻内容',
						trigger: 'blur'
					}],
					news_type: [{
						required: true,
						message: '请选择新闻类型',
						trigger: 'change'
					}]
				},
				classRules: {
					class_name: [{
							required: true,
							message: '请输入栏目名称',
							trigger: 'blur'
						},
						{
							max: 20,
							message: '长度不能超过20个字符',
							trigger: 'blur'
						}
					]
				},
				isEdit: false,
				editorSettings: {
					modules: {
						toolbar: [
							['bold', 'italic', 'underline'],
							[{
								'list': 'ordered'
							}, {
								'list': 'bullet'
							}],
							['image', 'code-block']
						]
					}
				},
				uploadUrl: `${apiBaseUrl}/upload.php`,
				classManagementVisible: false,
				classDialogTitle: '新增栏目',
			};
		},
		created() {
			this.fetchNewsList();
			this.fetchClassList();
		},
		methods: {
			getTypeTag(type) {
				const map = {
					message: '',
					active: 'warning',
					notice: 'success'
				};
				return map[type] || '';
			},
			getTypeName(type) {
				const map = {
					message: '消息',
					active: '活动',
					notice: '公告'
				};
				return map[type] || type;
			},
			getClassName(classId) {
				const classItem = this.classList.find(item => item.id == classId);
				return classItem ? classItem.class_name : '未分类';
			},
			async fetchNewsList() {
				try {
					const response = await fetch(`${apiBaseUrl}/news.php`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify({
							action: 'list',
							page: this.pagination.currentPage,
							pageSize: this.pagination.pageSize,
							title: this.filter.title,
							type: this.filter.type,
							status: this.filter.status !== 'all' ? this.filter.status : null,
							class_id: this.filter.class_id
						}),
					});

					const data = await response.json();

					if (data.success) {
						this.newsList = data.data;
						this.pagination.total = parseInt(data.total);
					} else {
						throw new Error(data.message || '获取新闻列表失败');
					}
				} catch (error) {
					this.$message.error(error.message);
					console.error('Error fetching news:', error);
				}
			},
			async fetchClassList() {
				try {
					const response = await fetch(`${apiBaseUrl}/news_class.php?action=list`);
					const data = await response.json();

					if (data.success) {
						this.classList = data.data;
					} else {
						throw new Error(data.message || '获取栏目列表失败');
					}
				} catch (error) {
					this.$message.error(error.message);
					console.error('Error fetching class list:', error);
				}
			},
			showAddDialog() {
				this.dialogTitle = '添加新闻';
				this.isEdit = false;
				this.form = {
					id: '',
					title: '',
					class_id: this.classList.length > 0 ? this.classList[0].id : '',
					cover_image: '',
					content: '',
					news_type: 'message',
					publish_time: new Date(),
					is_published: 0
				};
				this.dialogVisible = true;
			},
			// showAddClassDialog() {
			// 	this.classForm = {
			// 		class_name: '',
			// 		order_by: 0
			// 	};
			// 	this.classDialogVisible = true;
			// },
			handleEdit(row) {
				this.dialogTitle = '编辑新闻';
				this.isEdit = true;
				this.form = {
					id: row.id,
					title: row.title,
					class_id: row.class_id,
					cover_image: row.cover_image,
					content: row.content,
					news_type: row.news_type,
					publish_time: row.publish_time,
					is_published: row.is_published,
				};
				this.dialogVisible = true;
			},
			async deleteFile() {
				await this.$confirm('确定要删除附件吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				});
				this.form.file = '';
				this.submitForm();

			},
			async submitForm() {
				try {
					const valid = await this.$refs.form.validate();
					if (!valid) return;

					const action = this.isEdit ? 'update' : 'add';
					const payload = {
						...this.form,
						action
					};

					// 转换日期格式
					if (payload.publish_time instanceof Date) {
						payload.publish_time = payload.publish_time.toISOString().replace('T', ' ').substring(0, 19);
					}

					const response = await fetch(`${apiBaseUrl}/news.php`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify(payload)
					});

					const data = await response.json();

					if (!data.success) {
						throw new Error(data.message || (this.isEdit ? '更新失败' : '添加失败'));
					}

					this.$message.success(this.isEdit ? '更新成功' : '添加成功');
					this.dialogVisible = false;
					this.fetchNewsList();
				} catch (error) {
					this.$message.error(error.message);
				}
			},
			// async submitClassForm() {
			// 	try {
			// 		const valid = await this.$refs.classForm.validate();
			// 		if (!valid) return;

			// 		const response = await fetch(`${apiBaseUrl}/news_class.php`, {
			// 			method: 'POST',
			// 			headers: {
			// 				'Content-Type': 'application/json'
			// 			},
			// 			body: JSON.stringify({
			// 				action: 'add',
			// 				...this.classForm
			// 			})
			// 		});

			// 		const data = await response.json();

			// 		if (!data.success) {
			// 			throw new Error(data.message || '添加失败');
			// 		}

			// 		this.$message.success('添加成功');
			// 		this.classDialogVisible = false;
			// 		await this.fetchClassList();

			// 		// 自动选择新添加的栏目
			// 		if (data.id) {
			// 			this.form.class_id = data.id;
			// 		}
			// 	} catch (error) {
			// 		this.$message.error(error.message);
			// 	}
			// },

			async handlePublish(id) {
				try {
					await this.$confirm('确定要发布该新闻吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					});

					const response = await fetch(`${apiBaseUrl}/news.php`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							action: 'publish',
							id
						})
					});

					const data = await response.json();

					if (!data.success) {
						throw new Error(data.message || '发布失败');
					}

					this.$message.success('发布成功');
					this.fetchNewsList();
				} catch (error) {
					if (error !== 'cancel') {
						this.$message.error(error.message);
					}
				}
			},
			async handleDelete(id) {
				try {
					await this.$confirm('确定要删除该新闻吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					});

					const response = await fetch(`${apiBaseUrl}/news.php`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							action: 'delete',
							id
						})
					});

					const data = await response.json();

					if (!data.success) {
						throw new Error(data.message || '删除失败');
					}

					this.$message.success('删除成功');
					this.fetchNewsList();
				} catch (error) {
					if (error !== 'cancel') {
						this.$message.error(error.message);
					}
				}
			},
			handleSizeChange(val) {
				this.pagination.pageSize = val;
				this.fetchNewsList();
			},
			handleCurrentChange(val) {
				this.pagination.currentPage = val;
				this.fetchNewsList();
			},
			resetForm() {
				this.$refs.form.resetFields();
			},
			handleUploadSuccess(response) {
				if (response.success) {
					this.form.cover_image = apiBaseUrl + '/' + response.data.path;
					this.$refs.form.validateField('cover_image');
				} else {
					this.$message.error(response.message || '上传失败');
				}
			},
			handleUploadFileSuccess(response) {
				if (response.success) {
					this.form.file = apiBaseUrl + '/' + response.data.path;
					this.$refs.form.validateField('file');
					this.$forceUpdate()
					console.log(this.form)
				} else {
					this.$message.error(response.message || '上传失败');
				}
			},
			beforeUpload(file) {
				const isImage = file.type.startsWith('image/');
				const isLt2M = file.size / 1024 / 1024 < 2;

				if (!isImage) {
					this.$message.error('上传文件只能是图片格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
				}
				return isImage && isLt2M;
			},
			handleImageAdded(file, Editor, cursorLocation, resetUploader) {
				const formData = new FormData()
				formData.append('file', file)

				fetch(`${apiBaseUrl}/upload.php`, {
						method: 'POST',
						body: formData
					})
					.then(response => response.json())
					.then(data => {
						if (data.success) {
							const url = `${apiBaseUrl}/${data.data.path}`
							Editor.insertEmbed(cursorLocation, 'image', url)
							resetUploader()
						} else {
							this.$message.error(data.message || '图片上传失败')
						}
					})
					.catch(() => {
						this.$message.error('图片上传失败')
					})
			},
			showClassManagement() {
				this.fetchClassListWithCount()
				this.classManagementVisible = true
			},

			// 获取栏目列表及每个栏目的新闻数量
			async fetchClassListWithCount() {
				try {
					const response = await fetch(`${apiBaseUrl}/news_class.php?action=list_with_count`)
					const data = await response.json()

					if (data.success) {
						this.classList = data.data
					} else {
						throw new Error(data.message || '获取栏目列表失败')
					}
				} catch (error) {
					this.$message.error(error.message)
				}
			},

			// 显示新增栏目对话框
			showAddClassDialog() {
				this.classDialogTitle = '新增栏目'
				this.classForm = {
					id: '',
					class_name: '',
					order_by: 0
				}
				this.classDialogVisible = true
			},

			// 显示编辑栏目对话框
			handleEditClass(row) {
				this.classDialogTitle = '编辑栏目'
				this.classForm = {
					id: row.id,
					class_name: row.class_name,
					order_by: row.order_by
				}
				this.classDialogVisible = true
			},

			// 提交栏目表单
			submitClassForm() {
				this.$refs.classForm.validate(async (valid) => {
					if (!valid) return

					try {
						const action = this.classForm.id ? 'update' : 'add'
						const response = await fetch(`${apiBaseUrl}/news_class.php`, {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
							},
							body: JSON.stringify({
								action,
								...this.classForm
							})
						})

						const data = await response.json()

						if (!data.success) {
							throw new Error(data.message || '操作失败')
						}

						this.$message.success('操作成功')
						this.classDialogVisible = false
						this.fetchClassListWithCount()
						this.fetchNewsList() // 刷新新闻列表
					} catch (error) {
						this.$message.error(error.message)
					}
				})
			},

			// 删除栏目
			handleDeleteClass(row) {
				this.$confirm(`确定要删除栏目 "${row.class_name}" 吗?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					try {
						const response = await fetch(`${apiBaseUrl}/news_class.php`, {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
							},
							body: JSON.stringify({
								action: 'delete',
								id: row.id
							})
						})

						const data = await response.json()

						if (!data.success) {
							throw new Error(data.message || '删除失败')
						}

						this.$message.success('删除成功')
						this.fetchClassListWithCount()
						this.fetchNewsList() // 刷新新闻列表
					} catch (error) {
						this.$message.error(error.message)
					}
				}).catch(() => {})
			},

			// 重置栏目表单
			resetClassForm() {
				this.$refs.classForm?.resetFields()
			}
		}
	};
</script>

<style scoped>
	.news-management {
		/* padding: 20px; */
	}

	.filter-row {
		margin-bottom: 20px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	/* 富文本编辑器样式调整 */
	.tox-tinymce {
		border-radius: 4px;
		border: 1px solid #DCDFE6;
	}

	.tox-tinymce:hover {
		border-color: #C0C4CC;
	}

	.tox-tinymce.tox-tinymce--focus {
		border-color: #409EFF;
	}

	.el-select-dropdown__item {
		padding: 0 !important;
	}

	.add-class-option {
		color: #409EFF;
		padding: 0 20px;
		line-height: 34px;
	}

	.add-class-option:hover {
		background-color: #f5f7fa;
	}


	.el-select-dropdown__item {
		padding-left: 20px !important;
	}

	/* 新增按钮样式 */
	.add-class-option {
		color: #409EFF;
		line-height: 34px;
	}

	.add-class-option:hover {
		background-color: #f5f7fa;
	}

	/* 确保下拉框宽度足够 */
	.el-select-dropdown {
		min-width: 300px !important;
	}

	/* 覆盖wangEditor默认样式 */
	.w-e-toolbar {
		background-color: #f8f8f8 !important;
		border-bottom: 1px solid #e8e8e8 !important;
	}

	.w-e-text-container {
		background-color: #fff !important;
		border: none !important;
	}
</style>